<template>
  <section :data-cy="dataCy">
    <AtomText
      :text="title"
      font-style="font-semibold"
      font-size="text-lg"
      :data-cy="dataCy ? `${dataCy}-title` : undefined"
    />
    <div class="mt-1">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  dataCy?: string;
}>();
</script>
